"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutsideClickController = void 0;
/**
 * host 바깥을 클릭하면 콜백을 호출하는 ReactiveController.
 *
 * 연결 시 document 리스너를 걸고 해제 시 대칭으로 정리하므로,
 * 컴포넌트마다 connectedCallback/disconnectedCallback에 같은 코드를 반복하지 않는다.
 * composedPath()로 shadow 경계를 넘어 host 포함 여부를 판별하기 때문에,
 * 트리거가 다른 컴포넌트의 shadow DOM에 끼워져도 정상 동작한다.
 */
class OutsideClickController {
    constructor(host, onOutside, options = {}) {
        this.host = host;
        this.onOutside = onOutside;
        this.options = options;
        this.handleOutsideEvent = (e) => {
            if (this.options.isOpen && !this.options.isOpen())
                return;
            const path = e.composedPath();
            if (path.includes(this.host))
                return;
            const safe = this.options.getSafeElements?.() ?? [];
            if (safe.some(el => el != null && path.includes(el)))
                return;
            this.onOutside();
        };
        host.addController(this);
    }
    hostConnected() {
        document.addEventListener('pointerdown', this.handleOutsideEvent);
    }
    hostDisconnected() {
        document.removeEventListener('pointerdown', this.handleOutsideEvent);
    }
}
exports.OutsideClickController = OutsideClickController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3V0c2lkZS1jbGljay1jb250cm9sbGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsib3V0c2lkZS1jbGljay1jb250cm9sbGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVdBOzs7Ozs7O0dBT0c7QUFDSCxNQUFhLHNCQUFzQjtJQUNqQyxZQUNVLElBQVUsRUFDVixTQUFxQixFQUNyQixVQUErQixFQUFFO1FBRmpDLFNBQUksR0FBSixJQUFJLENBQU07UUFDVixjQUFTLEdBQVQsU0FBUyxDQUFZO1FBQ3JCLFlBQU8sR0FBUCxPQUFPLENBQTBCO1FBYW5DLHVCQUFrQixHQUFHLENBQUMsQ0FBUSxFQUFFLEVBQUU7WUFDeEMsSUFBSSxJQUFJLENBQUMsT0FBTyxDQUFDLE1BQU0sSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsTUFBTSxFQUFFO2dCQUFFLE9BQU07WUFDekQsTUFBTSxJQUFJLEdBQUcsQ0FBQyxDQUFDLFlBQVksRUFBRSxDQUFBO1lBQzdCLElBQUksSUFBSSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDO2dCQUFFLE9BQU07WUFDcEMsTUFBTSxJQUFJLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBQyxlQUFlLEVBQUUsRUFBRSxJQUFJLEVBQUUsQ0FBQTtZQUNuRCxJQUFJLElBQUksQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLEVBQUUsQ0FBQyxFQUFFLElBQUksSUFBSSxJQUFJLElBQUksQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDLENBQUM7Z0JBQUUsT0FBTTtZQUM1RCxJQUFJLENBQUMsU0FBUyxFQUFFLENBQUE7UUFDbEIsQ0FBQyxDQUFBO1FBbEJDLElBQUksQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDMUIsQ0FBQztJQUVELGFBQWE7UUFDWCxRQUFRLENBQUMsZ0JBQWdCLENBQUMsYUFBYSxFQUFFLElBQUksQ0FBQyxrQkFBa0IsQ0FBQyxDQUFBO0lBQ25FLENBQUM7SUFFRCxnQkFBZ0I7UUFDZCxRQUFRLENBQUMsbUJBQW1CLENBQUMsYUFBYSxFQUFFLElBQUksQ0FBQyxrQkFBa0IsQ0FBQyxDQUFBO0lBQ3RFLENBQUM7Q0FVRjtBQXpCRCx3REF5QkMifQ==